// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1oGub","footer":"ModalFilter_footer__X4kFV"};